import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: auto;
  display: flex;
`;

export const Main = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: row;
  margin-top: 6px;
  padding: 6px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.surface.surface};
`;

export const MainLeft = styled.div`
  display: flex;
`;

export const MainContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-left: 10px;
`;
